var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pushMessage'),_c('nav-bar',{attrs:{"state":_vm.stateIf},on:{"sx":_vm.refreshh}}),_c('keep-alive',[(_vm.routerAlive)?_c('router-view'):_vm._e()],1),_c('footerBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }